export default "__VITE_ASSET__DwOZeZJj__"